import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index'
import Success from '@/pages/success'
import Timeout from '@/pages/timeout'
import fail from '@/pages/fail'
import mpesa from '@/pages/mpesa/index'
import Msuccess from '@/pages/mpesa/success'
import Mfail from '@/pages/mpesa/fail'
import McardNumber from '@/pages/mpesa/cardNumber'
import Order from '@/pages/mpesa/order'
import Processing from '@/pages/mpesa/processing'
Vue.use(Router)

export default new Router({
  mode: 'hash', // require service support
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/success',
      name: 'success',
      component: Success
    },
    {
      path: '/timeout',
      name: 'timeout',
      component: Timeout
    },
    {
      path: '/fail',
      name: 'fail',
      component: fail
    },
    {
      path: '/mpesa',
      name: 'mpesa',
      component: mpesa
    },
    {
      path: '/mpesa/success',
      name: 'success',
      component: Msuccess
    },
    {
      path: '/mpesa/fail',
      name: 'fail',
      component: Mfail
    },
    {
      path: '/mpesa/cardNumber',
      name: 'cardNumber',
      component: McardNumber
    },{
      path: '/mpesa/order',
      name: 'order',
      component: Order
    },
    {
      path: '/mpesa/processing',
      name: 'processing',
      component: Processing
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js